import * as FullStory from "@fullstory/browser";
FullStory.init({ orgId: "o-1A5RSP-na1" });

export default FullStory;
